import { Turnstile, TurnstileInstance } from '@marsidev/react-turnstile'
import { useRef, useState } from 'react'
import { useForm } from 'react-final-form'

import { faCircleCheck } from '@fortawesome/pro-light-svg-icons/faCircleCheck'
import { FORM_ERROR } from 'final-form'

import { Heading } from '@infura/packages.ui/Heading'
import { Modal, ModalProps } from '@infura/packages.ui/Modal'
import { SemanticIcon } from '@infura/packages.ui/SemanticIcon'

import { siteKey } from 'lib/turnstile'

const NUM_RETRIES = 3

export function CaptchaModal(props: Readonly<ModalProps>) {
  const form = useForm()
  const ref = useRef<TurnstileInstance>()
  const [retries, setRetries] = useState(0)

  const handleError = (msg: string) => {
    if (retries < NUM_RETRIES) {
      setRetries(r => r++)
      return
    }
    form.change(FORM_ERROR, msg)
    props.setIsOpen(false)
    form.submit()
  }

  const handleToken = (token: string) => {
    form.change('recaptcha', token)
    props.setIsOpen(false)
    form.submit()
  }

  return (
    <>
      <Modal unmount={false} {...props}>
        <div className='flex flex-col items-center justify-center'>
          <SemanticIcon className='absolute top-6' icon={faCircleCheck} theme='warning' />
          <Heading className='mb-6 mt-6' theme='section'>
            Verify You Are Human
          </Heading>
          <Turnstile
            className='z-60'
            onError={() => handleError('Failed to solve captcha.')}
            onExpire={() => handleError('Failed to solve within time window, please refresh and try again.')}
            onSuccess={handleToken}
            onUnsupported={() => handleError('Browser unsupported by captcha provider.')}
            options={{ language: 'en', refreshExpired: 'never', retryInterval: 100, size: 'normal', theme: 'light' }}
            ref={ref}
            siteKey={siteKey}
          />
        </div>
      </Modal>
    </>
  )
}
